import { useState } from "react";
import { BiHide, BiShow } from "react-icons/bi";
import MeritoButton from "../MeritoButtons/MeritoButtons";
import styles from "./MeritoPasswordField.module.scss";

interface MeritoPasswordFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
  autoComplete?: string;
  onEnter?: () => void;
  id?: string;
}

const MeritoPasswordField = ({
  value,
  onChange,
  placeholder = "Enter password",
  error = false,
  disabled = false,
  autoComplete = "off",
  onEnter,
  id,
}: MeritoPasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div
      className={`${styles.field} ${error ? styles.error : ""} ${
        disabled ? styles.disabled : ""
      }`}
    >
      <input
        // Never type="password": browsers treat that as a login credential and
        // offer saved email/password pairs. A text input masked with CSS gets
        // no such treatment; the data-* attributes opt out of the extensions.
        id={id}
        type="text"
        className={showPassword ? "" : styles.masked}
        value={value}
        placeholder={placeholder}
        autoComplete={autoComplete}
        data-1p-ignore
        data-lpignore="true"
        data-bwignore
        data-form-type="other"
        spellCheck={false}
        disabled={disabled}
        aria-invalid={error || undefined}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key !== "Enter" || !onEnter) return;
          event.preventDefault();
          onEnter();
        }}
      />
      <MeritoButton
        type="tertiary"
        size="md2"
        onlyIcon
        hover={false}
        disabled={disabled}
        ariaLabel={showPassword ? "Hide password" : "Show password"}
        className={styles.visibilityButton}
        icon={showPassword ? <BiHide /> : <BiShow />}
        onClick={() => setShowPassword((current) => !current)}
      />
    </div>
  );
};

export default MeritoPasswordField;
